import { Absence } from '../absences/types';
import { Shift } from '../shifts/types';
import { TiminatorAbsenceType, TiminatorType } from '../types/types';
import { TimeSheetItem, TimeSheetItemStatus } from './types';

export const isShiftDirty = (item: TimeSheetItem, shift: Shift): boolean => {
    return shift.date !== item.date
        || shift.project.id !== item.targetId
        || shift.shiftType.id !== item.timeshiftTypeId
        || shift.hours !== item.hours
        || shift.comment !== item.note
        || shift.note !== item.internalNote
        || !isStatusAreEqual(item, shift);
}

export const isAbsenceDirty = (item: TimeSheetItem, absence: Absence): boolean => {
    return absence.date !== item.date
        || absence.hours !== item.hours
        || absence.comment !== item.note
        || absence.note !== item.internalNote
        || absence.absenceType.id !== item.targetId
        || !isStatusAreEqual(item, absence);
};

export const isStatusAreEqual = (item: TimeSheetItem, storedItem: Shift | Absence): boolean => {
    if (item.status === TimeSheetItemStatus.BILLABLE) {
        return isShift(storedItem) && storedItem.approved && storedItem.billable;
    }

    if (item.status === TimeSheetItemStatus.APPROVED) {
        return isShift(storedItem) ? !storedItem.billable && storedItem.approved : storedItem.approved;
    }

    return isShift(storedItem) ? !storedItem.approved && !storedItem.billable : !storedItem.approved;
}

export const isShift = (obj: any): obj is Shift => {
    return obj != undefined && 'employeeId' in obj && 'shiftType' in obj;
}

export const isAbsence = (obj: any): obj is Absence => {
    return obj != undefined && 'employeeId' in obj && 'absenceType' in obj;
}

export const asShift = (item: TimeSheetItem, shift: Shift, type: TiminatorType): Shift => {
    const upd = {...shift};

    upd.date = item.date;
    upd.shiftType = type;
    upd.hours = item.hours;
    upd.comment = item.note;
    upd.note = item.internalNote;
    upd.enteredHoursString = `${item.hours}`;
    upd.approved = item.status === TimeSheetItemStatus.APPROVED || item.status === TimeSheetItemStatus.BILLABLE;
    upd.billable = item.status === TimeSheetItemStatus.BILLABLE;
    upd.project = { id: item.targetId } as Shift['project'];

    return upd;
}

export const asAbsence = (item: TimeSheetItem, absence: Absence, type?: TiminatorAbsenceType): Absence => {
    const upd = {...absence};

    upd.date = item.date;
    upd.hours = item.hours;
    upd.enteredHoursString = item.hours.toString();
    upd.comment = item.note;
    upd.note = item.internalNote;
    upd.absenceType = type ?? absence.absenceType;
    upd.approved = item.status === TimeSheetItemStatus.APPROVED;

    return upd;
}
